export default __webpack_public_path__ + "static/media/Chat.6cc94af1.svg";